import _slicedToArray from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { AbortError } from "@azure/abort-controller";
import { RestError } from "./restError.js";
import { createHttpHeaders } from "./httpHeaders.js";
import { isNodeReadableStream, isWebReadableStream } from "./util/typeGuards.js";
/**
 * Checks if the body is a Blob or Blob-like
 */

function isBlob(body) {
  // File objects count as a type of Blob, so we want to use instanceof explicitly
  return (typeof Blob === "function" || typeof Blob === "object") && body instanceof Blob;
}
/**
 * A HttpClient implementation that uses window.fetch to send HTTP requests.
 * @internal
 */


var FetchHttpClient = /*#__PURE__*/function () {
  function FetchHttpClient() {
    _classCallCheck(this, FetchHttpClient);
  }

  _createClass(FetchHttpClient, [{
    key: "sendRequest",
    value:
    /**
     * Makes a request over an underlying transport layer and returns the response.
     * @param request - The request to be made.
     */
    function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var url, isInsecure;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = new URL(request.url);
                isInsecure = url.protocol !== "https:";

                if (!(isInsecure && !request.allowInsecureConnection)) {
                  _context.next = 4;
                  break;
                }

                throw new Error("Cannot connect to ".concat(request.url, " while allowInsecureConnection is false."));

              case 4:
                if (!request.proxySettings) {
                  _context.next = 6;
                  break;
                }

                throw new Error("HTTP proxy is not supported in browser environment");

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return makeRequest(request);

              case 9:
                return _context.abrupt("return", _context.sent);

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](6);
                throw getError(_context.t0, request);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 12]]);
      }));

      function sendRequest(_x) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  }]);

  return FetchHttpClient;
}();
/**
 * Sends a request
 */


function makeRequest(_x2) {
  return _makeRequest.apply(this, arguments);
}
/**
 * Creates a pipeline response from a Fetch response;
 */


function _makeRequest() {
  _makeRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(request) {
    var _setupAbortSignal, abortController, abortControllerCleanup, headers, _buildRequestBody, streaming, requestBody, requestInit, response;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _setupAbortSignal = setupAbortSignal(request), abortController = _setupAbortSignal.abortController, abortControllerCleanup = _setupAbortSignal.abortControllerCleanup;
            _context3.prev = 1;
            headers = buildFetchHeaders(request.headers);
            _buildRequestBody = buildRequestBody(request), streaming = _buildRequestBody.streaming, requestBody = _buildRequestBody.body;
            requestInit = Object.assign(Object.assign({
              body: requestBody,
              method: request.method,
              headers: headers,
              signal: abortController.signal
            }, "credentials" in Request.prototype ? {
              credentials: request.withCredentials ? "include" : "same-origin"
            } : {}), "cache" in Request.prototype ? {
              cache: "no-store"
            } : {}); // According to https://fetch.spec.whatwg.org/#fetch-method,
            // init.duplex must be set when body is a ReadableStream object.
            // currently "half" is the only valid value.

            if (streaming) {
              requestInit.duplex = "half";
            }
            /**
             * Developers of the future:
             * Do not set redirect: "manual" as part
             * of request options.
             * It will not work as you expect.
             */


            _context3.next = 8;
            return fetch(request.url, requestInit);

          case 8:
            response = _context3.sent;

            // If we're uploading a blob, we need to fire the progress event manually
            if (isBlob(request.body) && request.onUploadProgress) {
              request.onUploadProgress({
                loadedBytes: request.body.size
              });
            }

            return _context3.abrupt("return", buildPipelineResponse(response, request, abortControllerCleanup));

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](1);
            abortControllerCleanup === null || abortControllerCleanup === void 0 ? void 0 : abortControllerCleanup();
            throw _context3.t0;

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 13]]);
  }));
  return _makeRequest.apply(this, arguments);
}

function buildPipelineResponse(_x3, _x4, _x5) {
  return _buildPipelineResponse.apply(this, arguments);
}

function _buildPipelineResponse() {
  _buildPipelineResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(httpResponse, request, abortControllerCleanup) {
    var _a, _b, headers, response, bodyStream, responseStream, _responseStream;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            headers = buildPipelineHeaders(httpResponse);
            response = {
              request: request,
              headers: headers,
              status: httpResponse.status
            };
            bodyStream = isWebReadableStream(httpResponse.body) ? buildBodyStream(httpResponse.body, {
              onProgress: request.onDownloadProgress,
              onEnd: abortControllerCleanup
            }) : httpResponse.body;

            if (!( // Value of POSITIVE_INFINITY in streamResponseStatusCodes is considered as any status code
            ((_a = request.streamResponseStatusCodes) === null || _a === void 0 ? void 0 : _a.has(Number.POSITIVE_INFINITY)) || ((_b = request.streamResponseStatusCodes) === null || _b === void 0 ? void 0 : _b.has(response.status)))) {
              _context4.next = 7;
              break;
            }

            if (request.enableBrowserStreams) {
              response.browserStreamBody = bodyStream !== null && bodyStream !== void 0 ? bodyStream : undefined;
            } else {
              responseStream = new Response(bodyStream);
              response.blobBody = responseStream.blob();
              abortControllerCleanup === null || abortControllerCleanup === void 0 ? void 0 : abortControllerCleanup();
            }

            _context4.next = 12;
            break;

          case 7:
            _responseStream = new Response(bodyStream);
            _context4.next = 10;
            return _responseStream.text();

          case 10:
            response.bodyAsText = _context4.sent;
            abortControllerCleanup === null || abortControllerCleanup === void 0 ? void 0 : abortControllerCleanup();

          case 12:
            return _context4.abrupt("return", response);

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _buildPipelineResponse.apply(this, arguments);
}

function setupAbortSignal(request) {
  var abortController = new AbortController(); // Cleanup function

  var abortControllerCleanup;
  /**
   * Attach an abort listener to the request
   */

  var abortListener;

  if (request.abortSignal) {
    if (request.abortSignal.aborted) {
      throw new AbortError("The operation was aborted.");
    }

    abortListener = function abortListener(event) {
      if (event.type === "abort") {
        abortController.abort();
      }
    };

    request.abortSignal.addEventListener("abort", abortListener);

    abortControllerCleanup = function abortControllerCleanup() {
      var _a;

      if (abortListener) {
        (_a = request.abortSignal) === null || _a === void 0 ? void 0 : _a.removeEventListener("abort", abortListener);
      }
    };
  } // If a timeout was passed, call the abort signal once the time elapses


  if (request.timeout > 0) {
    setTimeout(function () {
      abortController.abort();
    }, request.timeout);
  }

  return {
    abortController: abortController,
    abortControllerCleanup: abortControllerCleanup
  };
}
/**
 * Gets the specific error
 */
// eslint-disable-next-line @azure/azure-sdk/ts-use-interface-parameters


function getError(e, request) {
  var _a;

  if (e && (e === null || e === void 0 ? void 0 : e.name) === "AbortError") {
    return e;
  } else {
    return new RestError("Error sending request: ".concat(e.message), {
      code: (_a = e === null || e === void 0 ? void 0 : e.code) !== null && _a !== void 0 ? _a : RestError.REQUEST_SEND_ERROR,
      request: request
    });
  }
}
/**
 * Converts PipelineRequest headers to Fetch headers
 */


function buildFetchHeaders(pipelineHeaders) {
  var headers = new Headers();

  var _iterator = _createForOfIteratorHelper(pipelineHeaders),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          name = _step$value[0],
          value = _step$value[1];

      headers.append(name, value);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return headers;
}

function buildPipelineHeaders(httpResponse) {
  var responseHeaders = createHttpHeaders();

  var _iterator2 = _createForOfIteratorHelper(httpResponse.headers),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
          name = _step2$value[0],
          value = _step2$value[1];

      responseHeaders.set(name, value);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return responseHeaders;
}

function buildRequestBody(request) {
  var body = typeof request.body === "function" ? request.body() : request.body;

  if (isNodeReadableStream(body)) {
    throw new Error("Node streams are not supported in browser environment.");
  }

  return isWebReadableStream(body) ? {
    streaming: true,
    body: buildBodyStream(body, {
      onProgress: request.onUploadProgress
    })
  } : {
    streaming: false,
    body: body
  };
}
/**
 * Reads the request/response original stream and stream it through a new
 * ReadableStream, this is done to be able to report progress in a way that
 * all modern browsers support. TransformStreams would be an alternative,
 * however they are not yet supported by all browsers i.e Firefox
 */


function buildBodyStream(readableStream) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var loadedBytes = 0;
  var onProgress = options.onProgress,
      onEnd = options.onEnd; // If the current browser supports pipeThrough we use a TransformStream
  // to report progress

  if (isTransformStreamSupported(readableStream)) {
    return readableStream.pipeThrough(new TransformStream({
      transform: function transform(chunk, controller) {
        if (chunk === null) {
          controller.terminate();
          return;
        }

        controller.enqueue(chunk);
        loadedBytes += chunk.length;

        if (onProgress) {
          onProgress({
            loadedBytes: loadedBytes
          });
        }
      },
      flush: function flush() {
        onEnd === null || onEnd === void 0 ? void 0 : onEnd();
      }
    }));
  } else {
    // If we can't use transform streams, wrap the original stream in a new readable stream
    // and use pull to enqueue each chunk and report progress.
    var reader = readableStream.getReader();
    return new ReadableStream({
      pull: function () {
        var _pull = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(controller) {
          var _a, _yield$reader$read, done, value;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return reader.read();

                case 2:
                  _yield$reader$read = _context2.sent;
                  done = _yield$reader$read.done;
                  value = _yield$reader$read.value;

                  if (!(done || !value)) {
                    _context2.next = 10;
                    break;
                  }

                  onEnd === null || onEnd === void 0 ? void 0 : onEnd(); // Close the stream

                  controller.close();
                  reader.releaseLock();
                  return _context2.abrupt("return");

                case 10:
                  loadedBytes += (_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0; // Enqueue the next data chunk into our target stream

                  controller.enqueue(value);

                  if (onProgress) {
                    onProgress({
                      loadedBytes: loadedBytes
                    });
                  }

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function pull(_x6) {
          return _pull.apply(this, arguments);
        }

        return pull;
      }(),
      cancel: function cancel(reason) {
        onEnd === null || onEnd === void 0 ? void 0 : onEnd();
        return reader.cancel(reason);
      }
    });
  }
}
/**
 * Create a new HttpClient instance for the browser environment.
 * @internal
 */


export function createFetchHttpClient() {
  return new FetchHttpClient();
}

function isTransformStreamSupported(readableStream) {
  return readableStream.pipeThrough !== undefined && self.TransformStream !== undefined;
}